import { render, staticRenderFns } from "./TaskChangeSettings.vue?vue&type=template&id=234328da&scoped=true"
import script from "./TaskChangeSettings.vue?vue&type=script&lang=ts"
export * from "./TaskChangeSettings.vue?vue&type=script&lang=ts"
import style0 from "./TaskChangeSettings.vue?vue&type=style&index=0&id=234328da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234328da",
  null
  
)

export default component.exports